import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@softline/core';
import {
  Command,
  CommandStore,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_TITLE,
  TitleStore
} from '@softline/application';
import {Router, RouterModule} from '@angular/router';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'soft-rdp-log-app',
    imports: [RouterModule],
    template: `
    <router-outlet></router-outlet>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: []
})
export class RdpLogAppComponent implements OnInit, OnDestroy {

  constructor(private store: Store, protected router: Router) {
  }

  async ngOnInit(): Promise<void> {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#RDP_LOG.TITLE');
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: RdpLogAppComponent,
      commands: this.createCommands()
    });
  }

  ngOnDestroy(): void {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.removeSet, RdpLogAppComponent);
  }

  protected createCommands(): Command[] {
    return [
      {
        icon: 'fa-regular fa-list',
        name: '#RDP_LOG.OVERVIEW',
        class: 'menu main-menu main-menu-top',
        routerLink: ['/rdp-log']
      },
      {
        icon: 'fa-regular fa-magnifying-glass',
        name: '#RDP_LOG.SEARCH',
        class: 'menu main-menu main-menu-top',
        routerLink: ['/rdp-log/search']
      },
    ];
  }
}
